import { ref } from "vue";
import { auth } from "../firebase/config.js";
import { onAuthStateChanged, signOut } from "firebase/auth";

async function firebaseSignOut() {
  await signOut(auth);
}

const user = ref(auth.currentUser);
onAuthStateChanged(auth, (_user) => {
  user.value = _user;
});

const getUser = () => {
  return { user };
};

export default {
  firebaseSignOut,
  getUser
}